import { Component, OnInit } from '@angular/core';

export abstract class InfiniteScrollableComponent implements OnInit {

  protected start = 0;

  constructor() { }

  ngOnInit() {
  }

  protected abstract getItemsPerPage(): number;

  protected abstract loadStreams(): void;

  public onScroll() {
    this.start += this.getItemsPerPage();

    this.loadStreams();
  }

}
